module.exports = __webpack_public_path__ + "static/media/zhiyinshouce1.05ebf3b1.png";